'use client';
import React__default, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyledToast, ToastContainer, IconContainer, ToastContent, Title, Content, CloseButtonContainer } from './Toast.styles.js';
import ButtonIcon from '../Inputs/Button/ButtonIcon/ButtonIcon.js';
import { BUTTON_VARIANT } from '../Inputs/Button/Button.constants.js';
import Icon from '../Icon/index.js';
import { FEEDBACK_ICONS, FEEDBACK_TYPES } from '../../constants/feedback.js';
import { closeAfterAnimation, isCountdownAnimation } from './Toast.helper.js';
import Typography from '../Typography/index.js';

var Toast = function Toast(_ref) {
  var type = _ref.type,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$timer = _ref.timer,
    timer = _ref$timer === void 0 ? 5000 : _ref$timer,
    _ref$onTimerEnd = _ref.onTimerEnd,
    onTimerEnd = _ref$onTimerEnd === void 0 ? undefined : _ref$onTimerEnd,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var dialogRef = useRef(null);
  var handleTimerEnd = onTimerEnd || onClose;
  useEffect(function () {
    if (isOpen) {
      var _dialogRef$current;
      (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 || _dialogRef$current.show();
    } else {
      var id = closeAfterAnimation(function () {
        var _dialogRef$current2;
        return (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 ? void 0 : _dialogRef$current2.close();
      });
      return function () {
        return clearTimeout(id);
      };
    }
    return undefined;
  }, [isOpen]);
  useEffect(function () {
    return function () {
      var _dialogRef$current3;
      (_dialogRef$current3 = dialogRef.current) === null || _dialogRef$current3 === void 0 || _dialogRef$current3.close();
    };
  }, [dialogRef]);
  var onAnimationEnd = function onAnimationEnd(event) {
    if (isCountdownAnimation(event)) {
      handleTimerEnd();
    }
  };
  return React__default.createElement(StyledToast, {
    "aria-label": title,
    ref: dialogRef,
    role: "dialog",
    tabIndex: "0",
    $type: type,
    onAnimationEnd: onAnimationEnd,
    className: isOpen ? '' : 'close-toast',
    $timer: timer,
    "data-testid": testId
  }, React__default.createElement(ToastContainer, null, React__default.createElement(IconContainer, {
    $type: type
  }, React__default.createElement(Icon, {
    variant: FEEDBACK_ICONS[type]
  })), React__default.createElement(ToastContent, null, React__default.createElement(Title, {
    as: Typography,
    variant: "headingMedium"
  }, title), React__default.createElement(Content, {
    as: Typography,
    variant: "bodyMedium"
  }, children)), React__default.createElement(CloseButtonContainer, {
    $hasTitle: !!title
  }, React__default.createElement(ButtonIcon, {
    icon: "Close",
    variant: BUTTON_VARIANT.GHOST,
    size: "tiny",
    onClick: onClose
  }, "close message"))));
};
Toast.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onTimerEnd: PropTypes.func,
  testId: PropTypes.string,
  timer: PropTypes.number,
  title: PropTypes.string,
  type: PropTypes.oneOf(Object.values(FEEDBACK_TYPES)).isRequired
};

export { Toast };
//# sourceMappingURL=Toast.js.map
